import { supabase } from '../lib/supabase';

let currentAdmin: { email: string; name: string } | null = null;

export function setCurrentAdmin(admin: { email: string; name: string } | null) {
  currentAdmin = admin;
}

export function getCurrentAdmin() {
  return currentAdmin;
}

export async function logAction(
  action: string,
  entityType: string | null,
  entityId: string | null,
  oldValue: any,
  newValue: any,
  description: string
) {
  try {
    await supabase.from('admin_logs').insert({
      admin_email: currentAdmin?.email || 'unknown',
      action,
      entity_type: entityType,
      entity_id: entityId,
      old_value: oldValue,
      new_value: newValue,
      description,
    });
  } catch (error) {
    console.error('Log error:', error);
  }
}
